<template>
  <div class="iv-main-footer">
    <ul>
      <li
        class="iv-pointer iv-fs-16"
        v-for="(item, inx) in concatList"
        :key="inx"
        @click="jumpUrl(item)"
      >
        {{ item.name }}
      </li>
    </ul>
    <p class="iv-m-t-20 iv-fs-14">北京牡丹电子集团有限责任公司 Copyright:Beijing Peony Electronic Group Co.,Ltd.京ICP备17007536号-1  </p>
    <p class="iv-m-t-12 iv-fs-14">京公网安备110401000087 IPv6 </p>
  </div>
</template>
<script>

export default {
  components: {},
  data () {
    return {
      concatList: []
    }
  },
  created () {
    // TODO 无跳转链接。去除该功能
    // this.setConcatList()
  },
  methods: {
    jumpUrl (item) {},
    setConcatList () {
      this.concatList = [
        { name: '常见问题', route: '' },
        { name: '联系我们', route: '' },
        { name: '关于我们', route: '' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/new-blue/variable.scss';
@media screen and (max-width: 1920px) {
  .iv-main-footer {
    min-width: 1200px !important;
  }
}
.iv-main-footer {
  width: 100%;
  height: 200px;
  padding: 50px 0;
  text-align: center;
  background-color: $iv-main-color;
  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    li {
      padding: 0 24px;
      color: #fff;
      border-right: 1px solid #fff;
      &:last-child {
        border-right: none;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
  p {
    color: $white-45;
  }
}
</style>
